<ngx-avatar [name]="fullName" [size]="size"></ngx-avatar>
